import { render, staticRenderFns } from "./popupModel.vue?vue&type=template&id=c58ab536&scoped=true&"
import script from "./popupModel.vue?vue&type=script&lang=js&"
export * from "./popupModel.vue?vue&type=script&lang=js&"
import style0 from "./popupModel.vue?vue&type=style&index=0&id=c58ab536&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58ab536",
  null
  
)

export default component.exports